// extracted by mini-css-extract-plugin
export default {"about_area":"About_about_area__pFvl0","contents":"About_contents__5Yr4b","box_wrapper":"About_box_wrapper__dpDQc"};